export enum MyOrdersTracingMessages {
  traceContext = 'my-orders',
  viewExceptionLinkClickOnMyOrdersEvent = 'Resolve Exceptions from My Orders',
  viewExceptionLinkClickOnOrderStatusEvent = 'Resolve Exceptions from Order Status',
  myOrdersCall = 'my orders call',
}
